<!-- 
  搜索组件
  @param defaultValue [String] 默认值
  @emit change(item) item = 变更的数据对象
 -->
<template>
  <ul class="search" @click.stop>
    <li class="select" v-show="hasHotelType">
      <el-radio v-model="hotelType" label="0" @change="hotCity.index = 0">境内酒店</el-radio>
      <el-radio v-model="hotelType" label="1" @change="hotCity.index = 0">境外酒店</el-radio>
    </li>
    <li>
      <p class="tit"><span>目的地</span></p>
      <input 
        class="city" 
        v-model="search.city" 
        type="text" 
        @focus="cityFocused"
        @input="updateCityValue"
        @blur="checkCity"
        placeholder="城市、机场、区域、地标或酒店名称"/>
      <figure class="citys" :class="{on: pop.hot}">
        <!-- <dl v-for="v in (hotCity[hotelType === '0' ? 'china' : 'global'])" :key="v.CityName_CN">
          <dt>{{v.CityName_CN}}</dt>
          <dd>
            <span v-for="sub in v.children" :key="sub.id" @click="changeCity(sub)">{{sub.CityName_CN}}</span>
          </dd>
        </dl> -->
        <dl>
          <dt>
            <span :class="{ on: hotCity.index === i }" v-for="(v, i) in getHotCityNav" :key="v.CityName_CN" @click="hotCity.index = i">{{v.CityName_CN}}</span>
          </dt>
          <dd>
            <span v-for="sub in getHotCitys" :key="sub.id" @click="changeCity(sub)">{{sub.CityName_CN}}</span>
          </dd>
        </dl>
      </figure>
      <figure class="search_list" :class="{on: pop.search}">
        <p v-for="v in list" :key="v.CityCode" @click="changeCity(v)"><span>{{v.CityName_CN}}</span><span>{{v.CityLongName_CN}}</span></p>
      </figure>
    </li>
    <li @click="clearPop">
      <p class="tit"><span>入住时间</span><span>退房时间</span></p>
      <p class="bold time" :data-count="getDateCount"><b>{{getStartDate}}</b><b>{{getEndDate}}</b></p>
      <el-date-picker
        v-model="search.time"
        type="daterange"
        value-format="yyyy-MM-dd"
        :unlink-panels="true"
        range-separator="至"
        :picker-options="pickerOptions"
        start-placeholder="入住时间"
        end-placeholder="退房时间">
      </el-date-picker>
    </li>
    <li @click="togglePop(!search.people, 'people')">
      <p class="tit"><span>房间及住客</span></p>
      <p class="bold"><b><strong>{{search.adult}}</strong>成人，<strong>{{search.minor}}</strong>儿童</b></p>
      <figure class="options" :class="{on: pop.people}" @click.stop>
        <p>
          <span>成人</span>
          <el-input-number v-model="search.adult" :min="1" :max="10" size="small"/>
        </p>
        <p>
          <span>儿童</span>
          <el-input-number v-model="search.minor" :min="0" :max="10" size="small"/>
        </p>
      </figure>
    </li>
    <li v-show="hasKeyWrod">
      <p class="tit"><span>关键词（选填）</span>`</p>
      <input class="keyword" v-model="search.keyword" type="text" placeholder="酒店名称或区域"/>
    </li>
    <li><button class="icon-sousuo" @click="getSearchData"></button></li>
  </ul>
</template>

<script>
import moment from 'moment';
let firstTime = null;
export default {
  props: {
    hasKeyWrod: {
      type: Boolean,
      defaultValue: false
    },
    hasHotelType: {
      type: Boolean,
      defaultValue: true
    },
    param: {
      type: Object,
      defaultValue: null
    }
  },
  data () {
    return {
      hotCity: {
        index: 0,
        china: [], // 境内热门
        global: [] // 境外热门
      },
      list: [], // 搜索列表
      hotelType: '1', // 酒店类型
      search: {
        city: null,
        cityObj: null,
        time: [],
        minor: 0,
        adult: 1,
        keyword: null
      },
      pop: {
        people: false,
        hot: false
      },
      pickerOptions: {
        disabledDate (date) {
          const diff = moment().diff(date, 'd');
          if ( firstTime !== null ) {
            const diff2 = Math.abs(moment(firstTime).diff(date, 'd'));
            return diff > 0 || diff2 >= 28;
          } else {
            return diff > 0;
          }
        },
        onPick ({ minDate, maxDate }) {
          if ( minDate && !maxDate ) {
            firstTime = minDate;
          } else {
            firstTime = null;
          }
        }
      }
    }
  },
  computed: {
    getHotCityNav () {
      const { hotelType, hotCity } = this;
      const hot = hotCity[hotelType === '0' ? 'china' : 'global'];
      return hot;
    },
    getHotCitys () {
      const { hotelType, hotCity } = this;
      const { index } = hotCity;
      const hot = hotCity[hotelType === '0' ? 'china' : 'global'];
      return hot[index] ? hot[index].children : {};
    },
    getStartDate () {
      const [first] = this.search.time;
      return first ? moment(first).format('MM月DD日') : '请选择';
    },
    getEndDate () {
      const [,end] = this.search.time;
      return end ? moment(end).format('MM月DD日') : '请选择';
    },
    getDateCount () {
      const [first, end] = this.search.time;
      return ( !!first === false || !!end === false ) ? '至' : `${Math.abs(moment(first).diff(end, 'd')) + 1}晚`;
    }
  },
  async created () {
    this.getHotCity();
    this.setInitDate();
    this.updateParam();
    document.querySelector('body').addEventListener('click', () => {
      const pop = this.resetPop();
      this.pop = pop;
    })
  },
  filters: {
  },
  methods: {
    updateParam () {
      const { param } = this;
      if ( !param ) { return; }
      this.search = {...this.search, ...param};
    },
    setInitDate () {
      const today = moment().format('YYYY-MM-DD');
      const tomorrow = moment(today).add(1, 'd').format('YYYY-MM-DD');
      this.search = { ...this.search, time: [today, tomorrow] };
    },
    getSearchData () {
      const { cityObj, adult, minor, time, keyword } = this.search;
      if ( !cityObj ) { this.$message.warning({ message: '请输入并选择目的地！' }); return; }
      const data = { adult, minor, time, city: cityObj, keyword };
      this.$emit('change', data);
    },
    checkCity () {
      setTimeout(() => {
        const { cityObj, city } = this.search;
        let search = { ...this.search };
        if ( !cityObj ) {
          search.city = null;
        } else { 
          cityObj.CityName_CN !== city && (search.city = cityObj.CityName_CN);
        }
        this.search = search;
      },100);
    },
    updateCityValue () {
      const { city } = this.search;
      let pop = this.resetPop();
      !city ? pop.hot = true : pop.search = true;
      this.pop = pop;
      if (city) {
        this.getSearchResult()
      }
    },
    async getSearchResult () {
      const { city } = this.search;
      const list = await this.$axios.post('/didaApi/searchCity', { keyword: city });
      this.list = list;
    },
    clearPop () {
      const pop = this.resetPop();
      this.pop = pop;
    },
    resetPop () {
      const pop = Object.keys(this.pop).reduce((obj, v) => {
        obj[v] = false;
        return obj;
      }, {});
      return pop;
    },
    cityFocused () {
      const { city } = this.search;
      !city && this.togglePop(true, 'hot');
    },
    togglePop (val, attr) {
      let pop = this.resetPop();
      pop = { ...pop, [attr]: val };
      this.pop = pop;
    },
    changeCity (item) {
      const search = { ...this.search, cityObj: item, city: item.CityName_CN };
      const pop = this.resetPop();
      this.search = search;
      this.pop = pop;
      this.togglePop(false, 'hot');
    },
    async getHotCity () {
      let chinaHotCity = await this.$axios.get('/didaApi/getDidaHotChinaCity');
      const [{ children: globalHotCity }] = await this.$axios.get('/didaApi/getDidaHotCity');
      chinaHotCity = [{ CityName_CN: '境内热门', children: chinaHotCity }];
      let hotCity = { china: chinaHotCity, global: globalHotCity, index: '0' };
      this.hotCity = hotCity;
    }
  }
}
</script>

<style scoped src="./index.css"></style>